<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/quality/sampling/procedure/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('chouyangguochengbianma')">
            <el-input v-model="yt.conditions.code"></el-input>
          </el-form-item>
          <el-form-item :label="$t('chouyangguochengmiaoshu')">
            <el-input v-model="yt.conditions.desc"></el-input>
          </el-form-item>
          <el-form-item :label="$t('chouyangleixing')">
            <el-select v-model="yt.conditions.samplingType" clearable>
              <el-option :label="$t('chouyangfangan')" :value="1"></el-option>
              <el-option :label="$t('100%chouyang')" :value="2"></el-option>
              <el-option :label="$t('gudingchouyang')" :value="3"></el-option>
              <el-option :label="$t('anbaifenbichouyang')" :value="4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear()">{{ $t('chongzhi') }}
            </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 抽样类型 -->
      <template #chouyangleixing="scope">
        <span v-if="scope.row.samplingType == 1">{{ $t('chouyangfangan') }}</span>
        <span v-if="scope.row.samplingType == 2">{{ $t('100%chouyang') }}</span>
        <span v-if="scope.row.samplingType == 3">{{ $t('gudingchouyang') }}</span>
        <span v-if="scope.row.samplingType == 4">{{ $t('anbaifenbichouyang') }}</span>
      </template>
      <!-- 严格度 -->
      <template #yangedu="scope">
        <span v-if="scope.row.level == 1">{{ $t('zhengchang') }}</span>
        <span v-if="scope.row.level == 2">{{ $t('fangkuan') }}</span>
        <span v-if="scope.row.level == 3">{{ $t('jiayan') }}</span>
      </template>

      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button size="mini" @click="yt.showEditDialog('xinzeng', null, 'w1'); setDefaultValue(); getPlanCode()" type="primary" v-if="utils.checkPower('web_quality_management_sampling_procedure_create')">
          {{ $t('xinzeng') }}
        </el-button>
        <el-button size="mini" @click="show = !show" plain v-if="utils.checkPower('web_quality_management_sampling_procedure_batchImport')">
          {{ $t('daoru') }}
        </el-button>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('bianji', scope.row); getPlanCode()" v-if="utils.checkPower('web_quality_management_sampling_procedure_update')">
              {{ $t('bianji') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" class="font-color-danger" v-if="utils.checkPower('web_quality_management_sampling_procedure_delete')" @click="yt.remove(scope.row, '/web/quality/sampling/procedure/delete')">{{ $t('shanchu') }}
            </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增 -->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <div class="dialog-scroller">
          <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
            <el-form-item :label="$t('chouyangleixing')" required>
              <el-select v-model="yt.editObj.samplingType" clearable @change="$forceUpdate()">
                <el-option :label="$t('chouyangfangan')" :value="1"></el-option>
                <el-option :label="$t('100%chouyang')" :value="2"></el-option>
                <el-option :label="$t('gudingchouyang')" :value="3"></el-option>
                <el-option :label="$t('anbaifenbichouyang')" :value="4"></el-option>
              </el-select>
            </el-form-item>
            <template v-if="yt.editObj.samplingType == 1">
              <el-form-item :label="$t('chouyangguochengbianma')" required>
                <el-input v-model="yt.editObj.code"></el-input>
              </el-form-item>
              <el-form-item :label="$t('chouyangguochengmiaoshu')" required>
                <el-input v-model="yt.editObj.desc"></el-input>
              </el-form-item>
              <el-form-item :label="$t('chouyangfanganbianma')" required>
                <el-select filterable :clearable="true" v-model="yt.editObj.samplingPlanId">
                  <el-option v-for="(item, index) in planCodeList" :key="index" :label="item.code" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('yangedu')" required>
                <el-select v-model="yt.editObj.level" clearable>
                  <el-option :label="$t('zhengchang')" :value="1"></el-option>
                  <el-option :label="$t('fangkuan')" :value="2"></el-option>
                  <el-option :label="$t('jiayan')" :value="3"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('AQL')" required>
                <el-input v-model="yt.editObj.aql"></el-input>
              </el-form-item>
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.enabled" clearable @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="true"></el-option>
                  <el-option :label="$t('fou')" :value="false"></el-option>
                </el-select>
              </el-form-item>
            </template>
            <!--3-固定抽样-->
            <template v-if="yt.editObj.samplingType == 3">
              <el-form-item :label="$t('chouyangguochengbianma')" required>
                <el-input v-model="yt.editObj.code"></el-input>
              </el-form-item>
              <el-form-item :label="$t('chouyangguochengmiaoshu')" required>
                <el-input v-model="yt.editObj.desc"></el-input>
              </el-form-item>
              <el-form-item :label="$t('yangbenshu')" required>
                <el-input v-model="yt.editObj.num" @input="(value) => {
      isNaN(value) ? isNaN(parseFloat(value)) ?
        yt.editObj.num = null : yt.editObj.num = parseFloat(value) : yt.editObj.num = value
    }"></el-input>
              </el-form-item>
              <el-form-item :label="$t('AC')" required>
                <el-input v-model="yt.editObj.ac"></el-input>
              </el-form-item>
              <el-form-item :label="$t('RE')" required>
                <el-input v-model="yt.editObj.re"></el-input>
              </el-form-item>
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.enabled" @change="$forceUpdate()" clearable>
                  <el-option :label="$t('shi')" :value="true"></el-option>
                  <el-option :label="$t('fou')" :value="false"></el-option>
                </el-select>
              </el-form-item>
            </template>
            <!--2-100%抽样-->
            <template v-if="yt.editObj.samplingType == 2">
              <el-form-item :label="$t('chouyangguochengbianma')" required>
                <el-input v-model="yt.editObj.code"></el-input>
              </el-form-item>
              <el-form-item :label="$t('chouyangguochengmiaoshu')" required>
                <el-input v-model="yt.editObj.desc"></el-input>
              </el-form-item>
              <el-form-item :label="$t('yangbenshu')">
                <el-input v-model="yt.editObj.num" @input="(value) => {
      isNaN(value) ? isNaN(parseFloat(value)) ?
        yt.editObj.num = null : yt.editObj.num = parseFloat(value) : yt.editObj.num = value
    }"></el-input>
              </el-form-item>
              <el-form-item :label="$t('AC')" required>
                <el-input v-model="yt.editObj.ac"></el-input>
              </el-form-item>
              <el-form-item :label="$t('RE')" required>
                <el-input v-model="yt.editObj.re"></el-input>
              </el-form-item>
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.enabled" @change="$forceUpdate()" clearable>
                  <el-option :label="$t('shi')" :value="true"></el-option>
                  <el-option :label="$t('fou')" :value="false"></el-option>
                </el-select>
              </el-form-item>
            </template>
            <!--4-按百分比抽样 -->
            <template v-if="yt.editObj.samplingType == 4">
              <el-form-item :label="$t('chouyangguochengbianma')" required>
                <el-input v-model="yt.editObj.code"></el-input>
              </el-form-item>
              <el-form-item :label="$t('chouyangguochengmiaoshu')" required>
                <el-input v-model="yt.editObj.desc"></el-input>
              </el-form-item>
              <el-form-item :label="$t('yangbenshu')" required>
                <el-input v-model="yt.editObj.num" @input="(value) => {
      isNaN(value) ? isNaN(parseFloat(value)) ?
        yt.editObj.num = null : yt.editObj.num = parseFloat(value) : yt.editObj.num = value
    }"></el-input>
              </el-form-item>
              <el-form-item :label="$t('AC')" required>
                <el-input v-model="yt.editObj.ac"></el-input>
              </el-form-item>
              <el-form-item :label="$t('RE')" required>
                <el-input v-model="yt.editObj.re"></el-input>
              </el-form-item>
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.enabled" @change="$forceUpdate()" clearable>
                  <el-option :label="$t('shi')" :value="true"></el-option>
                  <el-option :label="$t('fou')" :value="false"></el-option>
                </el-select>
              </el-form-item>
            </template>
          </el-form>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" :loading="yt.editObj.loading" @click="yt.req('POST', '/web/quality/sampling/procedure/create')" type="primary" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '抽样过程-新增抽样过程' } }">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <!-- 编辑 -->
      <template v-if="yt.editObj.action == 'bianji'">
        <div class="dialog-scroller">
          <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
            <el-form-item :label="$t('chouyangleixing')" required>
              <el-select v-model="yt.editObj.samplingType" clearable @change="$forceUpdate()">
                <el-option :label="$t('chouyangfangan')" :value="1"></el-option>
                <el-option :label="$t('100%chouyang')" :value="2"></el-option>
                <el-option :label="$t('gudingchouyang')" :value="3"></el-option>
                <el-option :label="$t('anbaifenbichouyang')" :value="4"></el-option>
              </el-select>
            </el-form-item>
            <template v-if="yt.editObj.samplingType == 1">
              <el-form-item class="noborder" :label="$t('chouyangguochengbianma')" required>
                <el-input disabled v-model="yt.editObj.code"></el-input>
              </el-form-item>
              <el-form-item :label="$t('chouyangguochengmiaoshu')" required>
                <el-input v-model="yt.editObj.desc"></el-input>
              </el-form-item>
              <el-form-item :label="$t('chouyangfanganbianma')" required>
                <el-select filterable :clearable="true" v-model="yt.editObj.samplingPlanId">
                  <el-option v-for="(item, index) in planCodeList" :key="index" :label="item.code" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('yangedu')" required>
                <el-select v-model="yt.editObj.level" clearable>
                  <el-option :label="$t('zhengchang')" :value="1"></el-option>
                  <el-option :label="$t('fangkuan')" :value="2"></el-option>
                  <el-option :label="$t('jiayan')" :value="3"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('AQL')" required>
                <el-input v-model="yt.editObj.aql"></el-input>
              </el-form-item>
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.enabled" clearable @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="true"></el-option>
                  <el-option :label="$t('fou')" :value="false"></el-option>
                </el-select>
              </el-form-item>
            </template>
            <!--3-固定抽样-->
            <template v-if="yt.editObj.samplingType == 3">
              <el-form-item class="noborder" :label="$t('chouyangguochengbianma')" required>
                <el-input disabled v-model="yt.editObj.code"></el-input>
              </el-form-item>
              <el-form-item :label="$t('chouyangguochengmiaoshu')" required>
                <el-input v-model="yt.editObj.desc"></el-input>
              </el-form-item>
              <el-form-item :label="$t('yangbenshu')" required>
                <el-input v-model="yt.editObj.num" @input="(value) => {
      isNaN(value) ? isNaN(parseFloat(value)) ?
        yt.editObj.num = null : yt.editObj.num = parseFloat(value) : yt.editObj.num = value
    }"></el-input>
              </el-form-item>
              <el-form-item :label="$t('AC')" required>
                <el-input v-model="yt.editObj.ac"></el-input>
              </el-form-item>
              <el-form-item :label="$t('RE')" required>
                <el-input v-model="yt.editObj.re"></el-input>
              </el-form-item>
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.enabled" @change="$forceUpdate()" clearable>
                  <el-option :label="$t('shi')" :value="true"></el-option>
                  <el-option :label="$t('fou')" :value="false"></el-option>
                </el-select>
              </el-form-item>
            </template>
            <!--2-100%抽样-->
            <template v-if="yt.editObj.samplingType == 2">
              <el-form-item class="noborder" :label="$t('chouyangguochengbianma')" required>
                <el-input disabled v-model="yt.editObj.code"></el-input>
              </el-form-item>
              <el-form-item :label="$t('chouyangguochengmiaoshu')" required>
                <el-input v-model="yt.editObj.desc"></el-input>
              </el-form-item>
              <el-form-item :label="$t('yangbenshu')">
                <el-input v-model="yt.editObj.num" @input="(value) => {
      isNaN(value) ? isNaN(parseFloat(value)) ?
        yt.editObj.num = null : yt.editObj.num = parseFloat(value) : yt.editObj.num = value
    }"></el-input>
              </el-form-item>
              <el-form-item :label="$t('AC')" required>
                <el-input v-model="yt.editObj.ac"></el-input>
              </el-form-item>
              <el-form-item :label="$t('RE')" required>
                <el-input v-model="yt.editObj.re"></el-input>
              </el-form-item>
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.enabled" @change="$forceUpdate()" clearable>
                  <el-option :label="$t('shi')" :value="true"></el-option>
                  <el-option :label="$t('fou')" :value="false"></el-option>
                </el-select>
              </el-form-item>
            </template>
            <!--4-按百分比抽样 -->
            <template v-if="yt.editObj.samplingType == 4">
              <el-form-item class="noborder" :label="$t('chouyangguochengbianma')" required>
                <el-input disabled v-model="yt.editObj.code"></el-input>
              </el-form-item>
              <el-form-item :label="$t('chouyangguochengmiaoshu')" required>
                <el-input v-model="yt.editObj.desc"></el-input>
              </el-form-item>
              <el-form-item :label="$t('yangbenshu')" required>
                <el-input v-model="yt.editObj.num" @input="(value) => {
      isNaN(value) ? isNaN(parseFloat(value)) ?
        yt.editObj.num = null : yt.editObj.num = parseFloat(value) : yt.editObj.num = value
    }"></el-input>
              </el-form-item>
              <el-form-item :label="$t('AC')" required>
                <el-input v-model="yt.editObj.ac"></el-input>
              </el-form-item>
              <el-form-item :label="$t('RE')" required>
                <el-input v-model="yt.editObj.re"></el-input>
              </el-form-item>
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.enabled" @change="$forceUpdate()" clearable>
                  <el-option :label="$t('shi')" :value="true"></el-option>
                  <el-option :label="$t('fou')" :value="false"></el-option>
                </el-select>
              </el-form-item>
            </template>
          </el-form>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" :loading="yt.editObj.loading" @click="yt.req('POST', '/web/quality/sampling/procedure/update')" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
    </el-dialog>
    <!-- 导入excel -->
    <import-excel :show.sync="show" />
  </div>
</template>
<script type="text/javascript">
import importExcel from './import_excel'
export default {
  name: 'web_quality_management_sampling_procedure_list',
  components: {
    importExcel
  },
  data() {
    return {
      planCodeList: [],
      show: false,
      exceptionTypeList: [],
      columns: [{
        label: 'chouyangguochengbianma',
        prop: 'code',
        width: 150,
      }, {
        label: 'chouyangguochengmiaoshu',
        prop: 'desc',
        width: 130,
      }, {
        label: 'chouyangleixing',
        prop: 'samplingType',
        type: 'slot',
        // width: 180,
      }, {
        label: 'chouyangfanganbianma',
        prop: 'samplingPlan.code',
        width: 130,
      }, {
        label: 'yangedu',
        prop: 'level',
        type: 'slot',
        width: 130,
      }, {
        label: 'AQL',
        prop: 'aql',
        width: 130,
      },
      {
        label: 'yangbenshu',
        prop: 'num',
        width: 130,
      },
      {
        label: 'AC',
        prop: 'ac',
        width: 130,
      },
      {
        label: 'RE',
        prop: 're',
        width: 130,
      },
      {
        label: 'shifouqiyong',
        prop: 'enabled',
        type: 'bool',
        iln18: ['shi', 'fou'],
      },
      {
        label: 'caozuo',
        type: 'slot',
        width: 150,
        fixed: 'right'
      }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.conditions = {
        // orderBy: 'createTime desc,triggerTime asc',
      }
      this.yt.SELECT_URL = "/web/quality/sampling/procedure/listByIds"
      this.yt.SELECT_RESULT_KEY = "data"
      this.yt.SELECT_ID = "id"
      this.yt.SELECT_TITLE = "name"
      this.yt.get(1);
      this.utils.event_hub.$on('QUALITY_MANAGEMENT_PROCEDURE_REFRESH', () => {
        this.yt.get(1);
      })
    }, 300)
  },

  methods: {
    getPlanCode() {
      this.http.get('web/quality/sampling/plan/page', {
        params: {
          pageNum: 1,
          pageSize: 1000
        }
      }).then(res => {
        this.planCodeList = res.data.rows
      })
    },
    setDefaultValue() {
      this.yt.editObj.samplingType = 1;
      this.yt.editObj.enabled = true
    },
  }
};
</script>
